<template lang="html">
    <div class="loading-fullscreen"></div>
</template>

<script>
export default {
    name: 'LoadingFullscreen',
    props: {
        text: {
            type: String,
            default: 'Chargement'
        }
    },
    data () {
        return {
            loading: null
        };
    },
    mounted () {
        this.loading = this.$loading({
            lock: true,
            text: this.text,
            background: 'rgba(255, 255, 255, 0.7)'
        });
    },
    beforeDestroy () {
        this.loading.close();
        this.loading = null;
    }
};
</script>



// WEBPACK FOOTER //
// src/components/partials/ui/LoadingFullscreen.vue